"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsWindowVisible = void 0;
var react_1 = require("react");
var VISIBILITY_STATE_SUPPORTED = 'visibilityState' in document;
var isWindowVisible = function () {
    return !VISIBILITY_STATE_SUPPORTED || document.visibilityState !== 'hidden';
};
/**
 * Returns whether the window is currently visible to the user.
 */
var useIsWindowVisible = function () {
    var _a = __read((0, react_1.useState)(isWindowVisible()), 2), focused = _a[0], setFocused = _a[1];
    var listener = (0, react_1.useCallback)(function () {
        setFocused(isWindowVisible());
    }, [setFocused]);
    (0, react_1.useEffect)(function () {
        if (!VISIBILITY_STATE_SUPPORTED)
            return undefined;
        document.addEventListener('visibilitychange', listener);
        return function () {
            document.removeEventListener('visibilitychange', listener);
        };
    }, [listener]);
    return focused;
};
exports.useIsWindowVisible = useIsWindowVisible;
exports.default = exports.useIsWindowVisible;
